import algoliasearch from 'algoliasearch/lite'
import { autocomplete, getAlgoliaResults } from '@algolia/autocomplete-js'

import '@algolia/autocomplete-theme-classic'

const goToSearchPage = (value) => {
  window.location.replace(window.location.origin + '?s=' + value)
}

const searchTest = () => {
  const searchClient = algoliasearch(
    window.ALGOLIA_APPLICATION_ID,
    window.ALGOLIA_SEARCH_API_KEY,
  )

  autocomplete({
    container: '#autocomplete',
    detachedMediaQuery: '',
    debug: false,
    onSubmit(query) {
      const keyword = query?.state?.query

      if (keyword) {
        goToSearchPage(keyword)
      }
    },

    getSources() {
      return [
        {
          sourceId: 'search',
          getItems({ query }) {
            return getAlgoliaResults({
              searchClient,
              queries: [
                {
                  indexName: 'wp_searchable_posts',
                  query,
                },
              ],
            })
          },
          templates: {
            noResults({ state, html }) {
              if (!state?.query) {
                return html` <p class="px-20 pt-20">
                  Start your search by typing a keyword in the search box above
                </p>`
              }

              return html`
                <p class="px-20 pt-20">
                  No results found for <strong>${state.query}</strong>
                </p>
              `
            },
            item({ item, html }) {
              return html`
                <article>
                  <a href="${item.permalink}">
                    <p class="aa-Label p--sm">${item.post_type}</p>
                    <h5>${item.post_title}</h5>
                  </a>
                </article>
              `
            },
          },
        },
      ]
    },
  })
}

export default searchTest
